import parse from "cssfontparser";

export function parseFont(font) {
    return parse(font);
}
//# sourceMappingURL=font.js.map
